import React from "react";
import { Form, Input, InputNumber } from "antd";

const { TextArea } = Input;

export const SectionForm = ({ form, onFinish }) => {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
    >
      <Form.Item
        name="name"
        label="nom de la zone"
        rules={[
          { required: true, message: "Veuillez entrer le nom de la section" },
        ]}
      >
        <Input placeholder="Entrez le nom de la zone" />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"

      >
        <TextArea rows={4} placeholder="Entrez la description de la zone" />
      </Form.Item>
    </Form>
  );
};
